import { put } from "redux-saga/effects";

import * as action from "../action";

export default function* ({ payload: { made_choices } }) {
  yield put(action.madeChoicesReceived(made_choices));
}
